import { BasicsClass } from "@/common/BasicsClass";


export class KTVOrderApi extends BasicsClass {

  public apiUrls: any = new Map([
    ['getOrderTableList', {
        url: '/admin/ktvOrder/list',
        name: 'list',
        label: '列表'
    }],
    // debugger changeExport;
    ['exportExcelOrderList', {
        url: '/admin/ktvOrder/exportList',
        name: 'export-excel',
        label: '导出'
    }],

])
  // 订单api 方法
  public getOrderTableList(
    params: any,
    successCb: Function,
    failCb: Function,
    showLoading: boolean = false
  ) {
    console.log(params, "params");

    const apiUrls = this.apiUrls

    const url = apiUrls.get('getOrderTableList').url

    this.BasicPost(url, {
        ...params
    }, false, false, false, successCb, failCb, showLoading)
  }

  public exportExcelOrderList(
    params: any,
    successCb: Function,
    failCb: Function,
    showLoading: boolean = false
  ) {
    const apiUrls = this.apiUrls

    const url = apiUrls.get('exportExcelOrderList').url

    this.BasicPost(url, {
        ...params
    }, false, false, false, successCb, failCb, showLoading)
  }

}
